import { render, staticRenderFns } from "./AdminPurchaseOrders.vue?vue&type=template&id=488d6cea"
import script from "./AdminPurchaseOrders.vue?vue&type=script&lang=js"
export * from "./AdminPurchaseOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports